import baseComponents from "@lekoarts/gatsby-theme-cara/src/gatsby-plugin-theme-ui/components"

const components = {
    ...baseComponents,
    DownloadCard: baseComponents.ProjectCard,
}

export default components
